import { useContext } from "react";

import { popupcontext } from "../../../context/Popupscontext";
import { useSelector } from "react-redux";

export default function EditAttachments({
	attachments,
	viewOnly,
	offlineAttachdiff,
}) {
	let { attachmentsId, setAttachmentsId } = useContext(popupcontext);
	const offlineMode = useSelector((state) => state.users.offlineMode);
	const handleGetAttachIds = (id) => {
		if (!attachmentsId.includes(id)) {
			setAttachmentsId((prevAttachmentsId) => [...prevAttachmentsId, id]);
		}
	};

	const handleUndo = (id) => {
		setAttachmentsId((prevAttachmentsId) =>
			prevAttachmentsId.filter((attachmentId) => attachmentId !== id),
		);
	};
	const getUrl = (type) => {
		if (!type) {
			return "/assets/Excel.svg"; // Default icon if type is undefined
		}
		const lowerCaseType = type.toLowerCase(); // Normalize to lowercase
		if (lowerCaseType === "image/png") {
			return "/assets/PNG.svg";
		} else if (
			lowerCaseType === "image/jpg" ||
			lowerCaseType === "image/jpeg"
		) {
			return "/assets/JPG.svg";
		} else if (lowerCaseType === "application/pdf") {
			return "/assets/PDF.svg";
		} else {
			return "/assets/Excel.svg";
		}
	};
	const truncateName = (name) => {
		if (!name) {
			return ""; // Return empty string if name is undefined or null
		}
		if (name.length > 9) {
			return `${name.substring(0, 9)}...`; // Truncate if longer than 10 chars
		}
		return name;
	};
	console.log("AttachmentsIds", attachmentsId);
	const displayAttachments =
		offlineMode && offlineAttachdiff
			? attachments?.slice(0, offlineAttachdiff)
			: attachments;
	let files = displayAttachments?.map((i, idx) => {
		const isUndo = attachmentsId.includes(i.id);
		// Support both API formats: fileName/fileType/filePath and name/type/url
		const fileName = i.name || i.fileName || "";
		const fileType = i.type || i.fileType || "";
		const fileUrl = i.url || i.filePath || "";
		return (
			<div
				key={i.id ? i.id : idx}
				className="col-lg-4 col-md-6 col-sm-4 mb-2"
				style={{ width: "fit-content" }}
			>
				{" "}
				<div className="attachments">
					<img src={`${getUrl(fileType)}`} width={28} alt="format" />
					<div className="d-flex justify-content-between">
						<a href={fileUrl} target="blank" className="me-2">
							{truncateName(fileName)}
						</a>
					</div>
					{!viewOnly && (
						<img
							src={
								isUndo
									? `${process.env.PUBLIC_URL}/assets/undo.svg`
									: `${process.env.PUBLIC_URL}/assets/Close.svg`
							}
							alt={isUndo ? "Undo" : "Remove"}
							width={20}
							role="button"
							onClick={() => {
								if (!offlineMode) {
									isUndo ? handleUndo(i.id) : handleGetAttachIds(i.id);
								} else {
									// Remove the attachment from the list by index in offline mode
									if (typeof attachments !== "undefined") {
										attachments.splice(idx, 1);
										setAttachmentsId([...attachmentsId]); // force update if needed
									}
								}
							}}
						/>
					)}
				</div>
			</div>
		);
	});

	return (
		<>
			<div className="row">{files}</div>
		</>
	);
}
